import localFont from 'next/font/local';

const ubuntu = localFont({
  src: [
    {
      path: './files/ubuntu-300-latin-ext.woff2',
      weight: '300',
      style: 'normal',
    },
    {
      path: './files/ubuntu-300-latin.woff2',
      weight: '300',
      style: 'normal',
    },
    {
      path: './files/ubuntu-400-latin-ext.woff2',
      weight: '400',
      style: 'normal',
    },
    {
      path: './files/ubuntu-400-latin.woff2',
      weight: '400',
      style: 'normal',
    },
    {
      path: './files/ubuntu-500-latin-ext.woff2',
      weight: '500',
      style: 'normal',
    },
    {
      path: './files/ubuntu-500-latin.woff2',
      weight: '500',
      style: 'normal',
    },
    {
      path: './files/ubuntu-700-latin-ext.woff2',
      weight: '700',
      style: 'normal',
    },
    {
      path: './files/ubuntu-700-latin.woff2',
      weight: '700',
      style: 'normal',
    },
  ],
  display: 'swap',
  variable: '--font-ubuntu',
});

export default ubuntu;
